const insightStatusTypes = Object.freeze({
  inProgressStatus: 'inProgressStatus',
  ignoredStatus: 'ignoredStatus',
  isBookmarkedStatus: 'isBookmarkedStatus'
});

const myInsightsTab = Object.freeze({
  allInsights: "allInsights",
  bookmarks: 'bookmarks',
  inProgress: 'inProgress',
  changes: 'changes'
})

const insightListingTypes = Object.freeze({
  packageDetail: 'packageDetail',
  myInsights: 'myInsights'
})


export {
  insightStatusTypes,
  myInsightsTab,
  insightListingTypes
}



// WEBPACK FOOTER //
// ./src/enums/insights/index.js